/**
 * 设计 token — V1.0 的"单一来源"。
 * 与 AntD ConfigProvider.theme.token 联动；不要在组件里硬编码颜色 / 间距字面量。
 *
 * 详见 ADR-0008 §"设计 token 走 src/styles/tokens.ts"
 */
export const tokens = {
  color: {
    primary: '#0071e3',
    success: '#059669',
    warning: '#d97706',
    danger: '#e30000',
    textPrimary: '#1d1d1f',
    textSecondary: '#6e6e73',
    bgLayout: '#f5f5f7',
    bgContainer: '#ffffff',
    border: '#d2d2d7',
  },
  space: {
    xs: 4,
    sm: 8,
    md: 16,
    lg: 24,
    xl: 32,
  },
  radius: {
    sm: 8,
    md: 12,
    lg: 16,
  },
  fontFamily:
    "-apple-system, BlinkMacSystemFont, 'SF Pro Text', 'Segoe UI', 'Noto Sans SC', sans-serif",
} as const;

export type Tokens = typeof tokens;
